module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_feeling03-cf77a25dfae3800b1dbe48b7182ae6db.svg";